import './Footer.scss';

export default function Footer({ ...rest }) {
  return (
    <footer
      onClick={() => window.open('https://neurasoft.co/', '_blank')}
      className={'footer'}
      {...rest}
    />
  );
}
